const fetch = require('app/www/libs/client/fetch');
const RESOURCES = require('app/configs/_routes').channel.api;

module.exports = {

    getSchedule(channelId, selectedDay) {
        const resource = RESOURCES.schedule.replace(/\(\:channelEngName\(\[\\w\-\]\+\-\)\)\?\:channelId\(\\d\+\)/gi, String(channelId));
        const param = selectedDay ? {selectedDay: selectedDay.date} : {};

        return fetch(resource, param);
    },

    getFavoriteChannels(channelIds) {
        return fetch(RESOURCES.favoriteChannels, {channelIds});
    },

};
